import translator from "../../../../components/localization/translator";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import React from "react";
import moment from "moment/moment";
import { PAYMENT_TYPES } from "../../../../config/constants";

const renderTipDate = (_, row) => {
    const value = row?.date || row?.transactionDate || row?.createdAt;
    return value ? moment(value).format("DD.MM.YYYY HH:mm") : "";
};

const renderTipAmount = (_, row) => {
    const value = row?.amount || row?.paidAmount;
    if (value == null || isNaN(value)) return "";
    return value;
};

const renderTipPaymentType = (_, row) => {
    const paymentType = row?.paymentType || row?.payment_type;
    if (!paymentType) return "";

    const paymentMethod = PAYMENT_TYPES.paymentMethodsById(paymentType);
    return paymentMethod?.name || paymentType;
};

const renderTipTransactionId = (_, row) => {
    return row?.transactionId || row?.transaction_id || row?.id || "";
};

const renderTipShare = (_, row) => {
    const tipShare = row?.tipShare || row?.tip_share || row?.deliveryTipShare;
    if (tipShare == null || isNaN(tipShare)) return "";
    return `${tipShare} %`;
};

const TipTransactionsTable = ({ data }) => {
    if (!data?.length) {
        return (
            <div>
                {translator.translate("_tip_transactions_not_found_")}
            </div>
        );
    }

    return (
        <BootstrapTable data={data} striped hover>
            <TableHeaderColumn isKey dataField="_id" hidden>
                _id
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="date"
                dataFormat={renderTipDate}
                width="180px"
            >
                {translator.translate("_date_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="paidAmount"
                dataFormat={renderTipAmount}
                width="180px"
            >
                {translator.translate("_paid_amount_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="paymentType"
                dataFormat={renderTipPaymentType}
                width="180px"
            >
                {translator.translate("_payment_type_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="transactionId"
                dataFormat={renderTipTransactionId}
                width="200px"
            >
                {translator.translate("_transaction_id_")}
            </TableHeaderColumn>

            <TableHeaderColumn
                dataField="tipShare"
                dataFormat={renderTipShare}
                width="180px"
            >
                {translator.translate("_tip_share_")}
            </TableHeaderColumn>
        </BootstrapTable>
    );
};

export default TipTransactionsTable
